import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapProjectsRevenueCorrelation = {
  show: async(props) => {
    const { default: RevenueCorrelation } = await import('@/vue_widgets/mlap/revenue_correlation/index.vue')
    createVueApp(RevenueCorrelation, { props })
  }
}
